<div class="decor__body">
    <div class="decor__start"></div>
    <div class="decor__end"></div>
    <div class="decor__center"></div>
</div>
